// extracted by mini-css-extract-plugin
export default {"Logo":"LogoLogin_Logo__DBwix"};